import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ms-4" }

import { ref } from 'vue';
import {
  GalleryImportIcon,
  AtomButton,
  AtomInput,
} from '@/components/atoms';

export default /*#__PURE__*/_defineComponent({
  __name: 'MoleculeUpload',
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

const emit = __emit;
const inputFile = ref<any>(null)
const fileName = ref<string>('')

function handleFile() {
  inputFile.value?.click()
}
function handleChangeFile() {
  fileName.value = inputFile.value?.files[0].name
  emit("update:modelValue", inputFile.value?.files[0])
}

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_col, {
      cols: "6",
      sm: "3"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(AtomInput), {
          type: "text",
          disabled: "",
          label: _ctx.$t('message.brands_create.brand_logo'),
          placeholder: fileName.value || _ctx.$t('message.brands_create.file_name')
        }, null, 8, ["label", "placeholder"])
      ]),
      _: 1
    }),
    _createVNode(_component_v_col, {
      cols: "6",
      sm: "3",
      class: "mt-7"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(AtomButton), {
          background: "transparent",
          class: "border",
          onClick: _withModifiers(handleFile, ["prevent"])
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(GalleryImportIcon), { class: "" }),
            _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.$t('message.brands_create.upload_image')), 1)
          ]),
          _: 1
        }),
        _createElementVNode("input", {
          ref_key: "inputFile",
          ref: inputFile,
          type: "file",
          class: "sr-only",
          accept: "image/*",
          onChange: handleChangeFile
        }, null, 544)
      ]),
      _: 1
    })
  ], 64))
}
}

})